import React from "react";

const ErrorPage = () => {
  return (
    <div className="error-div text-align-center">
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="82"
          height="70"
          viewBox="0 0 82 70"
        >
          <g id="error" transform="translate(-922 -345)">
            <path
              id="다각형_1"
              data-name="다각형 1"
              d="M32.371,14.732a10,10,0,0,1,17.258,0L73.183,54.946A10,10,0,0,1,64.554,70H17.446A10,10,0,0,1,8.817,54.946Z"
              transform="translate(922 345)"
              fill="#2b2b2b"
            />
            <path
              id="패스_75646"
              data-name="패스 75646"
              d="M2.1-8.359H-1.982l-.449-20.078h5ZM-2.568-2.236a2.506,2.506,0,0,1,.723-1.839A2.651,2.651,0,0,1,.127-4.8a2.651,2.651,0,0,1,1.973.73,2.506,2.506,0,0,1,.723,1.839,2.46,2.46,0,0,1-.7,1.79A2.658,2.658,0,0,1,.127.273a2.658,2.658,0,0,1-1.992-.72A2.46,2.46,0,0,1-2.568-2.236Z"
              transform="translate(963 405)"
              fill="#fff"
            />
          </g>
        </svg>
      </div>
      <p className="error-title">일시적인 서비스 오류가 발생했습니다.</p>
      <p className="error-comment" />
      방문하시려는 페이지의 주소가 잘못 입력되었거나,
      <br />
      페이지의 주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을수 없습니다.
      <br />
      입력하신 주소가 정확한지 다시 한번 확인해 주시기 바랍니다.
      <a className="error-prev-btn" href="javascript:history.back();">
        이전 페이지로
      </a>
      <div className="copyright">
        <p>COPYRIGHT&copy; 2022 airsound. ALL RIGHTS RESERVED.</p>
      </div>
    </div>
  );
};

export default ErrorPage;
